import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { PennyTestComponent } from "./penny-test.component";

const routes: Routes = [
	{
		path: "",
		component: PennyTestComponent
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class PennyTestRoutingModule {}
